import { render } from "./Embedded.vue?vue&type=template&id=cbb08672"
import script from "./Embedded.vue?vue&type=script&lang=js"
export * from "./Embedded.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__